import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Section from '../components/Section';

export default function Thanks() {
  const [params] = useSearchParams();
  const email = params.get('email') || '';
  const provider = params.get('provider') || 'google';
  const deeplink = params.get('deeplink') || '';
  const token = params.get('token') || '';
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    // Trigger deep link to app (v2 features) if provided, then go to thanks. Deeplink is vpnee://auth?...
    if (deeplink) {
      try {
        const url = decodeURIComponent(deeplink);
        // Attempt app open
        setTimeout(() => { try { window.location.href = url; } catch {} }, 400);
      } catch {}
    } else if (email && token) {
      // Fallback: construct deep link from email/provider/token
      const url = `vpnee://auth?email=${encodeURIComponent(email)}&provider=${encodeURIComponent(provider)}&token=${encodeURIComponent(token)}`;
      setTimeout(() => { try { window.location.href = url; } catch {} }, 500);
    }
    // Auto-close this browser tab after thank-you (hide API endpoint flow)
    const t = setTimeout(() => {
      setClosing(true);
      try { window.close(); } catch {}
      setTimeout(() => setClosing(false), 1500);
    }, 2500);
    return () => clearTimeout(t);
  }, [deeplink, email, provider, token]);

  return (
    <Section chip="Success" title="You're authenticated — thank you!" subtitle={`Signed in via ${provider} as ${email || 'your account'}. You can safely close this tab and return to the app.`}>
      <div className="glass p-8 sm:p-10 text-center max-w-xl mx-auto">
        <div className="w-16 h-16 mx-auto rounded-2xl grid place-items-center bg-[color:var(--color-brand)]/15 border border-[color:var(--color-brand)]/30 text-[color:var(--color-brand)] mb-4">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2}><path d="M20 6L9 17l-5-5" /></svg>
        </div>
        <h3 className="font-[family-name:var(--font-display)] text-xl font-bold">Authentication complete</h3>
        {email && <p className="text-sm text-[color:var(--color-ink-dim)] mt-2">Logged in as <b className="text-white">{email}</b></p>}
        <p className="text-sm text-[color:var(--color-ink-dim)] mt-3">This window will close automatically. If it doesn't, close it manually and open <b>Vpnee</b> app — you're already signed in.</p>
        <div className="mt-6 flex flex-wrap gap-3 justify-center">
          <button onClick={() => { try { window.close(); } catch {}; }} className="btn btn-primary">
            {closing ? 'Closing…' : 'Close window'}
          </button>
          <Link to="/" className="btn btn-ghost">Go to homepage</Link>
          <Link to="/account" className="btn btn-ghost">Open account</Link>
        </div>
        <p className="text-xs text-[color:var(--color-ink-faint)] mt-6">You will not see any API endpoint — this is your thank-you page on vpnee.tnidu.com.</p>
      </div>
    </Section>
  );
}
